<template>
  <div class="admin-noticeboard p-4 bg-white rounded-lg shadow-md relative flex flex-col gap-4 h-full">
    <div class="justify-between flex border-b-2 pb-2 items-center">
      <span class="text-lg  font-bold text-primary">
        NDA’s Requiring Qualification
      </span>
    </div>

    <div
      v-if="!isLoading"
      class="overflow-y-auto show-y-thin-scrollbar px-4 flex-auto"
    >
      <div
        v-if="businesses.length === 0"
        class="flex items -center justify-center h-full"
      >
        <p class="text-gray-500 text-center">
          No CA's requiring qualification
        </p>
      </div>
      <div
        v-else
        class="flex-auto"
      >
        <ul class="list-disc list-outside">
          <nuxt-link
            v-for="(business, index) in businesses"
            :key="index"
            :to="`/businesses/${business.id}/details/prospect-manager`"
            class="flex flex-col group w-full  py-2 rounded-md hover:bg-gray-100 transition-colors duration-300"
          >
            <div
              class="grid grid-cols-8 gap-2 border-b cursor-pointer items-center"
            >
              <div class="flex items-center justify-between col-span-5">
                <p class="font-semibold text-gray-800">
                  {{ business.name }}
                </p>
              </div>
              <span class="text-sm text-gray-600 text-center col-span-2">
                {{ business.numberOfCACompleted }} awaiting
              </span>

              <div class="flex justify-end col-span-1">
                <Icon
                  name="iconamoon:link-external-thin"
                  class="w-5 h-5 text-gray-500 hover:text-gray-700 transition-colors duration-300"
                />
              </div>
            </div>
          </nuxt-link>
        </ul>
      </div>
    </div>
    <div
      v-else
      class="flex items-center justify-center h-full"
    >
      <ProgressSpinner />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'

const { getAllBusinessesCAcompleted } = useDashboard()

const isLoading = ref(true)

// const userState = ref({ uid: 'user-123' })

// const isAdmin = computed(() => false)

// const requestedCIM = ref([
//   { sharedId: 'abc123' },
//   { sharedId: 'abc123' },
//   { sharedId: 'xyz789' },
//   { sharedId: 'xyz789' },
//   { sharedId: 'lmn456' },
// ])

// const sharedLinks = ref([
//   { id: 'abc123', businessId: 'biz001' },
//   { id: 'xyz789', businessId: 'biz002' },
//   { id: 'lmn456', businessId: 'biz003' },
// ])

// const businesses = ref([
//   {
//     id: 'biz001',
//     businessName: 'The Robina Pavilion',
//     agents: ['user-123'],
//   },
//   {
//     id: 'biz002',
//     businessName: 'Umbrella Inc.',
//     agents: ['user-456'],
//   },
//   {
//     id: 'biz003',
//     businessName: 'Entesta 2',
//     agents: ['user-123', 'user-789'],
//   },
// ])

// const processedRequestedList = ref([])

// const debounceTimeout: ReturnType<typeof setTimeout> | null = null
// watch(
//   () => requestedCIM.value,
//   (newRequestedCIM) => {
//     if (debounceTimeout) clearTimeout(debounceTimeout)
//     debounceTimeout = setTimeout(() => {
//       computeProcessedList(newRequestedCIM).then((result) => {
//         processedRequestedList.value = result
//       })
//     }, 300)
//   },
//   { immediate: true, deep: true },
// )

const businesses = ref([])
const init = async () => {
  isLoading.value = true
  const res = await getAllBusinessesCAcompleted()
  businesses.value = res?.data
  isLoading.value = false
}
onMounted(async () => {
  await init()

  // computeProcessedList(requestedCIM.value).then((result) => {
  //   processedRequestedList.value = result
  // })
})

// function aggregateCIMs(cims: any[]) {
//   const map = new Map()
//   for (const cim of cims) {
//     if (!cim.sharedId) continue
//     const current = map.get(cim.sharedId) || { sharedId: cim.sharedId, count: 0 }
//     map.set(cim.sharedId, { ...current, count: current.count + 1 })
//   }
//   return map
// }

// async function computeProcessedList(cimCollection: any[]) {
//   isLoading.value = true
//   const aggregated = aggregateCIMs(cimCollection)
//   const result: any[] = []

//   for (const cim of aggregated.values()) {
//     const sharedLink = getSharedLink(cim.sharedId)
//     if (!sharedLink) continue

//     const business = getBusiness(sharedLink.businessId)
//     if (!business) continue

//     const userId = userState.value.uid
//     if (!isAdmin.value && !business.agents.includes(userId)) {
//       continue
//     }

//     cim.business = { id: business.id, name: business.businessName }
//     result.push(cim)
//   }

//   isLoading.value = false
//   return result
// }

// function getSharedLink(sharedId: string) {
//   return sharedLinks.value.find(link => link.id === sharedId)
// }

// function getBusiness(businessId: string) {
//   return businesses.value.find(biz => biz.id === businessId)
// }

// function openLink(businessId: string) {
//   console.log(`Navigating to business ID: ${businessId}`)
//   useRouter().push(`/businesses`)
// }
</script>
